<template>
    <div>
        <v-breadcrumbs :items="crumbs" divider="/" style="background-color: #f0f0f0">
        </v-breadcrumbs>
        <v-card class="mx-auto" outlined tile color="#F8F8FF">
        <v-card-title>Notification</v-card-title>
        <v-container class="fill-height"
        fluid>
            <v-row>
                <v-btn-toggle class="col-12 col-md-6 offset-md-6" style="background: none">
                    <v-btn small disabled>
                        <v-icon small>fa fa-search</v-icon>
                    </v-btn>
                    <v-text-field placeholder="Search" class="search-textfield" hide-details outlined dense v-model="search"></v-text-field>
                </v-btn-toggle>
                <v-col cols="12" md="12">
                    <v-autocomplete
                    dense
                    outlined
                    placeholder="All"
                    label="Message Category"
                    v-model="category.selected"
                    @change="execFilter('category')"
                    :items="category.items"
                    item-text="name"
                    item-value="categoryid"
                    :rules="category.rule"
                    :loading="category.loader"
                    :disabled="category.disable"
                    hide-details
                    >
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                    <v-autocomplete
                    dense
                    outlined
                    placeholder="All"
                    label="Message Read Status"
                    v-model="notificationisread.selected"
                    @change="execFilter('isread')"
                    :items="notificationisread.items"
                    item-text="name"
                    item-value="id"
                    :rules="notificationisread.rule"
                    :loading="notificationisread.loader"
                    :disabled="notificationisread.disable"
                    hide-details
                    >
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-pagination
                    v-model="page"
                    :length.sync="pages"
                    :total-visible="6"
                    class="mt-4"
                    style="float: left !important"
                    ></v-pagination><br/><p class="text-caption" style="margin-left: 10px">Page {{page}} of {{pages}}</p>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col><span class="text-body-2">View {{page > 1 ? (page - 1) * 100 + 1 : 1}} - {{getCount}} of {{totalrecords}}</span></v-col>
                <v-col cols="12" md="12">
                    <v-overlay
                    :absolute="true"
                    :value="overlay"
                    >
                        <v-progress-circular
                    indeterminate
                    color="primary"
                    ></v-progress-circular>
                    </v-overlay>
                    <v-data-table
                        calculate-widths
                        :headers="headers"
                        :items="items"
                        hide-default-footer
                        :loading="tableloading"
                        loading-text= "Loading Data... Please wait"
                        :items-per-page="100"
                        id="main-table"
                        sort-by="CreatedDateTime"
                        dense
                    >
                    <template slot="item" slot-scope="props">
                        <tr>
                            <td>{{page > 1 ? (page - 1) * 100 + props.index + 1 : props.index + 1}}</td>
                            <td>
                                <v-tooltip top v-if="validateAccess('n_viewdetails')">
                                <template v-slot:activator="{ on }">
                                    <a v-on="on" style="text-decoration: underline" id="custom-hover" @click.prevent="viewMore(props.item, 'view')">{{props.item.notificationid}}</a>
                                </template>
                                <span>View</span>
                                </v-tooltip>
                                <span v-else>{{props.item.notificationid}}</span>
                            </td>
                            <td>{{props.item.notificationloginmobileid}}</td>
                            <td>{{props.item.name}}</td>
                            <td>{{props.item.phonenumber}}</td>
                            <td>{{props.item.notificationcategoryid}} - {{props.item.notificationcategoryname}}</td>
                            <td>{{props.item.notificationtitle}}</td>
                            <td>{{props.item.notificationcreateddatetime}}</td>
                            <td>{{props.item.notificationstatus}}</td>
                            <td>{{props.item.notificationisread}}</td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
        </v-card>
        <v-snackbar
        v-model="swal.notification"
        top
        :color="swal.scolor"
        >
            {{ swal.message }}
        </v-snackbar>
        <create :dialog="ma.modal" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" :allInfo="ma.allInfo" @confirm="onConfirm" @closed="onClosed"></create>
        <edit :dialog="ma.modal_update" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" :readonly="ma.readonly" :allInfo="ma.allInfo" @delete="onDelete" @confirm="onConfirm" @closed="onClosed"></edit>
        <alert :dialog="ma.modal_status" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" @confirm="onConfirm" @closed="onClosed"></alert>
        <alertbox2 :dialog="ex.modal" @closed="onClosed" :content="ex.content"></alertbox2>
    </div>
</template>
<script>
import timer from '../../assets/js/sleeper';
import create from '.././modals/CreateMessageCategory';
import edit from '.././modals/UpdatePushNotification';
import alert from '.././modals/Alert';
import {ERR} from '../../assets/js/errhandle.js';
import alertbox2 from '../modals/Notification';
import * as moment from "moment";
import * as tz from "moment-timezone";
import {rule} from '../../assets/js/checkPerm';

export default {
    name: 'Notification',
    title: 'Notification',
    
    data()  {
        return {
            crumbs: [
                {
                text: 'Home',
                disabled: true,
                href: '#',
                },

                {
                text: 'Message',
                disabled: true,
                href: '#',
                },

                {
                text: 'Push Notification',
                disabled: true,
                href: '#',
                },

                {
                text: 'Notification',
                disabled: true,
                href: '#',
                },
            ],
            items: [],
            search: '',
            /*
            5. Notification -> table -> #, Message ID, Mobile ID, Name, Mobile No., Message Category,  Message Title, Created Date, Sent Status, Read Status
            */
            headers: [
                { text: '#', value: 'row', width: '3%' },
                { text: 'Message ID', value: 'categoryid', width: '3%' },
                { text: 'Mobile ID', value: 'categoryname', width: '5%' },
                { text: 'Name', value: 'categoryname', width: '5%' },
                { text: 'Mobile No.', value: 'categoryname', width: '5%' },
                { text: 'Message Category', value: 'categoryname', width: '5%' },
                { text: 'Message Title', value: 'categoryname', width: '5%' },
                { text: 'Created Date', value: 'categorycreateddatetime', width: '10%', sort: function (a, b) {
                    let aa = moment(a, 'DD-MM-YYYY hh:mm:ss A');
                    let aa2 = aa.toDate();

                    let bb = moment(b, 'DD-MM-YYYY hh:mm:ss A');
                    let bb2 = bb.toDate();

                    return aa2 > bb2 ? -1 : aa2 < bb2 ? 1 : 0;
                }  },
                { text: 'Sent Status', value: 'categoryname', width: '5%' },
                { text: 'Read Status', value: 'categoryname', width: '5%' },
            ],
            tableloading: false,
            btn_loading: false,
            pages: 0,
            page: 1,
            swal: {
                notification: false,
                message: '',
                scolor: '',
            },
            ma: {
                modal: false,
                modal_action_type: '',
                modalInfo: [],
                customText: [],
                confirmCreate: false,

                modal_status: false,
                modal_update: false,
                readonly: true,
                allInfo: [],
            },

            ex: {
                modal: false,
                content: {
                    headline: '',
                    icon: '',
                    chipColor: '',
                    iconColor: '',
                    maintext: '',
                    smalltext: ''
                }
            },

            category: {
                items: [],
                itemsFull: [],
                selected: '',
                loader: false,
                disable: false,
                rule: []
            },

            notificationisread: {
                items: [
                    {id: 'null', name: 'All'},
                    {id: '0', name: 'Not Read'},
                    {id: '1', name: 'Read'}
                ],
                itemsFull: [],
                selected: 'null',
                loader: false,
                disable: false,
                rule: []
            },

            services: [],
            totalrecords: '',
            overlay: false
        }
    },

    components: {create, edit, alert, alertbox2},

    watch: {
        page: {
        handler: function(value) {
            this.items = [];
            this.listAll();
        }
        },

        'search': {
        handler: function(value) {
            this.searchTimeOut();
        }
        }
    },

    computed: {
        getCount(){
            if (this.items.length > 0)
                return this.items[this.items.length - 1].row;

            else{
                return '';
            }
        },
    },

    async created(){
        await this.getMessageCategory();
        this.listAll(1);
    },

    methods: {
        async listAll(pg){
            try{
                this.tableloading = true;
                let response = await this.$store.dispatch("getPushNotification", {page: pg > 0 ? this.page = pg : this.page, search: this.search, notificationcategoryid: this.category.selected, notificationisread: this.notificationisread.selected});

                let dt = response.data.record;
                
                let recordCount = response.data.recordcount;
                this.totalrecords = recordCount;

                for(var i=0; i<dt.length; i++){
                        dt[i].row = this.page > 1 ? (this.page - 1) * 100 + i + 1 : i + 1;
                        dt[i].name = dt[i].name == null ? "N/A" : dt[i].name;
                        dt[i].phonenumber = dt[i].phonenumber == null ? "N/A" : dt[i].phonenumber;
                        dt[i].notificationmessage = dt[i].notificationmessage == null ? "N/A" : dt[i].notificationmessage;
                        dt[i].notificationisread = dt[i].notificationisread == 1 ? "Read" : 'Not Read';
                        dt[i].notificationcreateddatetime = dt[i].notificationcreateddatetime == null ? "N/A" : moment(new Date(dt[i].notificationcreateddatetime)).format('DD-MM-YYYY hh:mm:ss A');
                        dt[i].notificationsentdatetime = dt[i].notificationsentdatetime == null ? "N/A" : moment(new Date(dt[i].notificationsentdatetime)).format('DD-MM-YYYY hh:mm:ss A');
                        dt[i].notificationisreaddatetime = dt[i].notificationisreaddatetime == null ? "N/A" : moment(new Date(dt[i].notificationisreaddatetime)).format('DD-MM-YYYY hh:mm:ss A');
                        dt[i].notificationdeleteddatetime = dt[i].notificationdeleteddatetime == null ? "N/A" : moment(new Date(dt[i].notificationdeleteddatetime)).format('DD-MM-YYYY hh:mm:ss A');
                }

                this.items = dt;
                this.pages = Math.ceil(recordCount / 100);
                this.tableloading = false;
                
            }

            catch(err){
                console.log(err);
            }
        },

        async getMessageCategory(){
            let list = [];
            this.category.items = [];
            this.category.selected = "";

            try{
                this.category.loader = true;
                this.category.disable = true;

                let self = this;
                let response = await this.$store.dispatch("getMessageCategory", {search: '', rowresultsperpage: 'null'});
                let dt = response.data.record;
                if (response.data.code == 'AP000'){
                    this.category.items.push({name: "All", categoryid: ""});
                    this.category.itemsFull.push({name: "All", categoryid: ""});

                for(var i=0; i<dt.length; i++){
                    dt[i].name = `${dt[i].categoryid} - ${dt[i].categoryname}`;
                    this.category.items.push({name: dt[i].name, categoryid: dt[i].categoryid});
                    this.category.itemsFull.push(dt[i]);
                }

                this.category.selected = this.category.items[0].categoryid;
                }

                //this.operator.itemsFull = dt;

                this.category.loader = false;
                this.category.disable = false;
            }

            catch(err){
                console.log(err);
            }

            return list;
        },

        validateAccess(val){
            let access = JSON.parse(JSON.stringify(this.$store.getters.getAccess))
            return rule.checkaccess(val, access);
        },

        async addOperator(v){
            this.btn_loading = true;
            this.tableloading = true;
            try{
                this.swal.scolor = 'green';
                let req = {
                    messagecategory: v.messagecategory.item,
                };
                let response = await this.$store.dispatch("createMessageCategory", req);
                if (response.data.code === 'AP000'){
                    await this.listAll();
                    this.swal.notification = true;
                    this.swal.scolor = 'green';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}: Message Category Created!`;
                }

                else{
                    this.loading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }

                this.tableloading = false;
                this.btn_loading = false;
            }

            catch(err){
                this.swal.notification = true;
                this.swal.scolor = 'red';
                this.swal.message = ERR.HANDLE(response.data.code);
            }
        },

        async operatorRemove(){
            try{
                this.tableloading = true;
                let response = await this.$store.dispatch("deletePushNotification", {notificationid: this.ma.modalInfo.notificationid})
                if (response.data.code === 'AP000'){
                        await this.listAll();

                        this.swal.notification = true;
                        this.swal.scolor = 'green';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Notification has been removed!`;
                }

                else{
                    this.loading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }

                this.tableloading = false;
            }

            catch(err){
                console.log(err);
                this.swal.scolor = 'red';
                this.swal.notification = true;
                this.swal.message = "Something went wrong. Please try again later";
                this.tableloading = false;
            }
        },

        async operatorUpdate(v){
            let req = {
                categoryid: this.ma.modalInfo.categoryid,
                categoryname: v.categoryname.item
            };

            try{
                this.tableloading = true;
                let response = await this.$store.dispatch("updateMessageCategory", req)
                if (response.data.code === 'AP000'){
                        await this.listAll();

                        this.swal.notification = true;
                        this.swal.scolor = 'green';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Message Category has been updated!`;
                }

                else if (response.data.code === 'RD002'){
                        this.swal.notification = true;
                        this.swal.scolor = 'red';
                        this.swal.message = `${ERR.HANDLE(response.data.code)}: Unable to update.`;
                }

                else{
                    this.loading = false;
                    this.swal.notification = true;
                    this.swal.scolor = 'red';
                    this.swal.message = `${ERR.HANDLE(response.data.code)}`;
                }

                this.tableloading = false;
            }

            catch(err){
                this.swal.scolor = 'red';
                this.swal.notification = true;
                this.swal.message = "Something went wrong. Please try again later";
                this.tableloading = false;
            }
        },

        async viewMore(row, flag){
            //this.autoRefresh = 0;
            if (flag == 'delete'){
                this.ma.modal_status = true;
                this.ma.modalInfo = row;
            }

            if (flag == 'create'){
                this.ma.modal = true;
                this.ma.allInfo = this.items;
            }

            if (flag == 'update'){
                this.ma.modal_update = true;
                this.ma.modalInfo = row;
                this.ma.allInfo = this.items;
                this.ma.readonly = false;
            }

            if (flag == 'view'){
                this.overlay = true;
                let response = await this.$store.dispatch("getNotificationItem", {notificationid: row.notificationid});
                this.overlay = false;
                let dt = response.data.record;
                let i = 0;
                dt[i].name = dt[i].name == null ? "N/A" : dt[i].name;
                dt[i].phonenumber = dt[i].phonenumber == null ? "N/A" : dt[i].phonenumber;
                dt[i].notificationmessage = dt[i].notificationmessage == null ? "N/A" : dt[i].notificationmessage;
                dt[i].notificationwebsiteurl = dt[i].notificationwebsiteurl == null ? "N/A" : dt[i].notificationwebsiteurl;
                dt[i].notificationimageurl = dt[i].notificationimageurl == null ? "https://www.abc-rentacar.co.jp/images/600x300b.gif" : dt[i].notificationimageurl;
                dt[i].notificationisread = dt[i].notificationisread == 1 ? "Read" : 'Not Read';
                dt[i].notificationcreateddatetime = dt[i].notificationcreateddatetime == null ? "N/A" : moment(new Date(dt[i].notificationcreateddatetime)).format('DD-MM-YYYY hh:mm:ss A');
                dt[i].notificationsentdatetime = dt[i].notificationsentdatetime == null ? "N/A" : moment(new Date(dt[i].notificationsentdatetime)).format('DD-MM-YYYY hh:mm:ss A');
                dt[i].notificationisreaddatetime = dt[i].notificationisreaddatetime == null ? "N/A" : moment(new Date(dt[i].notificationisreaddatetime)).format('DD-MM-YYYY hh:mm:ss A');
                dt[i].notificationdeleteddatetime = dt[i].notificationdeleteddatetime == null ? "N/A" : moment(new Date(dt[i].notificationdeleteddatetime)).format('DD-MM-YYYY hh:mm:ss A');
                this.ma.modal_update = true;
                this.ma.modalInfo = response.data.record[0];
                this.ma.allInfo = this.items;
                this.ma.readonly = true;
            }

            this.ma.customText = {text1: "Gate ID", text2: "Name"};
            this.ma.modal_action_type = flag;
        },

        viewProfile(row){
            this.ma.modalInfo = row;
            this.$router.push({ name: "Admin Profile", params: {id: row.userID}, query: {email: row.email}});
        },

        viewSOC(row){
            this.ma.modalInfo = row;
            this.$router.push({ name: "Admin SOC", params: {id: row.userID}, query: {email: row.email}});
        },

        onClosed(value){
            console.log(value)
            if (value == false){
                this.ma.modal = value;
                this.ma.modal_status = value;
                this.ma.modal_update = value;
                this.ex.modal = value;
            }
        },

        onConfirm(value){
            console.log('aa', value)
            if (value.flag === 'create'){
                this.ma.confirmCreate = true;
                this.ma.modal = false;
                this.addOperator(value);
            }

            if (value.flag === 'update'){
                this.ma.modal_update = false;
                this.operatorUpdate(value);
            }
        },

        onDelete(){
            this.ma.modal_update = false;
            this.operatorRemove();
        },

        async execFilter(type){
            if (type == 'category'){
                await this.searchTimeOut();
            }

            if (type == 'isread'){
                await this.searchTimeOut();
            }
        },

        searchTimeOut() {

          clearTimeout(this.timeout);

          // Make a new timeout set to go off in 800ms
          this.timeout = setTimeout(() => {
          this.listAll();
          }, 800);
        },

        statusCheck(val, typ){
            if (typ == 'text'){
                    if (val === 1){ return 'Enabled'}
                    else if (val === 0){return 'Disabled'}
                    else {return 'null'}
            }

            if (typ == 'color'){
                    if (val === 1){ return 'green'}
                    else if (val === 0){return 'red'}
                    else {return 'grey'}
            }
        },

        mobileDisplayStatus(val, typ){
            if (typ == 'text'){
                    if (val === 1){ return 'Yes'}
                    else if (val === 0){return 'No'}
                    else {return 'null'}
            }

            if (typ == 'color'){
                    if (val === 1){ return 'green'}
                    else if (val === 0){return 'red'}
                    else {return 'grey'}
            }
        },
    }
}
</script>